/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AccessCodeExtractReportFrequencyType {
  None = 'None',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  OnExpiry = 'OnExpiry'
}
